import styled from '@emotion/styled'

export const ContentWrapper = styled.div`
  display: flex;
  height: 100%;
`

export const IllustrationContainer = styled.div`
  height: clamp(160px, 40vh, 180px);

  svg {
    width: auto;
    height: 100%;
  }
`
